




import setupBackBtn from './modules/back-btn';
import setupSubmenuHover from './modules/submenu-hover';
import setupQuickNav from './modules/quicknav';
import setupMobileNav from './modules/mobile-nav';
import setupNews from './modules/news';





setupBackBtn();
setupSubmenuHover();
setupQuickNav();
setupMobileNav();
setupNews();






document.addEventListener('DOMContentLoaded', _ => {
    const overlayButtons = document.querySelectorAll('[href="#offerte-aanvragen"], [href="#productkiezer"], [href="#vrijblijvende-offerte-aanvragen"]');

    overlayButtons.forEach(overlayButton => {
        const name = overlayButton.href.split('#')[1];

        const body = document.querySelector(`body`);
        const overlay = document.querySelector(`.${name}-overlay`);
        const steps = overlay.querySelector('.steps');
        const stepsNav = overlay.querySelector('.steps-nav');
        const prevStep = overlay.querySelector('.prev-step');
        const nextStep = overlay.querySelector('.next-step');
        const lastStep = overlay.querySelector('.last-step');
        const productgroepCheckbox = overlay.querySelectorAll('.button-checkbox');
        const productList = overlay.querySelector('.product-list');

        const maxSteps = steps.querySelectorAll('.step').length;
        const widthPercentage = 100 / maxSteps;

        let currentStep = 1;

        const size = window.innerWidth < 750 ? window.innerWidth : 750;
        steps.style.width = maxSteps * size + 'px';

        function setupFormUrl () {
            const productgroepBtn = overlay.querySelector('input.productgroep:checked');
            if ( productgroepBtn ) {
                overlay.action = productgroepBtn.value;
                nextStep.disabled = false;
            }
        }


        function updateModal (step) {
            const pos = (step - 1) * widthPercentage;
            steps.style.transform = `translateX(-${pos}%)`;

            if ( prevStep ) {
                if ( step > 1 ) {
                    prevStep.style.display = 'block';
                } else {
                    prevStep.style.display = 'none';
                }
            }

            if ( nextStep && lastStep ) {
                if ( step === maxSteps && lastStep ) {
                    nextStep.style.display = 'none';
                    lastStep.style.display = 'block';
                } else {
                    nextStep.style.display = 'block';
                    lastStep.style.display = 'none';
                }
            }

            if ( !prevStep && !nextStep ) {
                lastStep.style.display = 'block';
            }

            window.setTimeout(() => {
                let current = steps.querySelector(`.step:nth-child(${currentStep})`);
                steps.style.height = current.offsetHeight + 'px';
            }, 1);

            if ( stepsNav ) {
                stepsNav.querySelectorAll('.step-nav').forEach( (elem, index) => {
                    elem.classList.remove('current', 'visited');

                    if ( step == index + 1) {
                        elem.classList.add('current');
                    } else if ( index + 1 < step ) {
                        elem.classList.add('visited');
                    }
                });
            }

            setupFormUrl();
        }

        function selectProducts (checkbox) {
            if ( !productList ) return;
            const productInList = productList.querySelector(`.gekozen-${checkbox.getAttribute('id')}`);

            if ( checkbox.checked ) {
                productInList.style.display = 'block';
            } else {
                productInList.style.display = 'none';
            }

            updateModal(currentStep);
        }

        function fillSelectedProducts () {
            if ( !productList ) return;
            const selectedProducts = [...productList.querySelectorAll('li')]
                .filter(elem => {
                    return elem.style.display == 'block';
                }).map(elem => {
                    return elem.querySelector('span').innerHTML;
                }).join(', ');


            const productInput = overlay.querySelector('input[name="product"]');
            if ( productInput ) {
                productInput.value = selectedProducts;
            }
        }

        if ( productgroepCheckbox ) {
            productgroepCheckbox.forEach(checkbox => {
                checkbox.addEventListener('change', _ => {
                    selectProducts(checkbox);
                    fillSelectedProducts();
                });
            })

        }

        if ( overlayButton ) {
            overlayButton.addEventListener('click', evt => {
                evt.preventDefault();

                currentStep = 1;
                updateModal(currentStep);
                overlay.style.display = 'flex';
                body.classList.add('overlay-open');

                if ( productgroepCheckbox ) {
                    productgroepCheckbox.forEach(selectProducts);
                }

                fillSelectedProducts();
                
            });

            overlay.addEventListener('click', evt => {
                if ( evt.target.classList.contains(`${name}-overlay`) ) {
                    overlay.style.display = 'none';
                body.classList.remove('overlay-open');
                }
            });

            if ( prevStep ) {
                prevStep.addEventListener('click', _ => {
                    if ( currentStep > 1 ) {
                        currentStep--;
                        updateModal(currentStep);
                    }
                });
            }

            if ( nextStep ) {
                nextStep.addEventListener('click', _ => {
                    if ( currentStep < maxSteps ) {
                        currentStep++;
                        updateModal(currentStep);
                    }
                });
            }

            if ( lastStep ) {
                lastStep.addEventListener('click', _ => {
                    const submitBtn = overlay.querySelector('.wpcf7-submit');
                    if ( submitBtn ) {
                        submitBtn.click();
                    }
                });
            }

            const productgroepBtns = overlay.querySelectorAll('input.productgroep');
            if ( productgroepBtns && productgroepBtns.length > 0 ) {
                productgroepBtns.forEach(btn => btn.addEventListener('change', setupFormUrl));
            }
        }
    });
});










const productImageContainer = document.querySelector('.product-images');
if ( productImageContainer ) {
    const productImageHolder =  productImageContainer.querySelector('.images-holder');
    const holderWidth = productImageHolder.offsetWidth;
    const thumbs = productImageHolder.querySelectorAll('.thumb');

    productImageHolder.style.width = thumbs.length * holderWidth + 'px';

    productImageContainer.querySelectorAll('.nav button').forEach( (btn, index) => {
        btn.addEventListener('click', () => {
            const offset = holderWidth * index;
            productImageHolder.style.transform = `translateX(-${offset}px)`;
        });
    });
}




const accItems = document.querySelectorAll('.accessoires li, .prijs');
if ( accItems ) {
    accItems.forEach(item => {
        const btn = item.querySelector('button');
        const overlay = item.nextSibling;

        if ( overlay && btn ) {
            const closeBtn = overlay.querySelector('.close-btn');

            btn.addEventListener('click', () => {
                overlay.classList.add('open');
            });

            closeBtn.addEventListener('click', () => {
                overlay.classList.remove('open');
            });

            overlay.addEventListener('click', evt => {
                if ( evt.target.classList.contains('side-overlay') ) {
                    overlay.classList.remove('open');
                }
            });
        }
    });
}

window.addEventListener('load', () => {
    const accesoireImages = document.querySelectorAll('.accessoires img');
    if ( accesoireImages ) {
        accesoireImages.forEach(img => {
            img.style.height = img.offsetWidth + 'px';
        });
    }
});






const itemExpander = function ( container, itemSelector, visibleItems = 3 ) {
    const items = container.querySelectorAll(itemSelector);
    const more = container.querySelector('.title .more');

    if ( more ) {
        if ( items.length > visibleItems ) {
            more.addEventListener('click', _ => {
                container.classList.toggle('all');
            });
        } else {
            more.remove();
        }
    }

    items.forEach((title, index) => {
        title.addEventListener('click', _ => {
            title.classList.toggle('active');
        });

        if ( index > visibleItems - 1 ) {
            title.classList.add('hidden');
        }
    });
}


const accordionContent = document.querySelectorAll('.content.accordion');

if ( accordionContent ) {
    accordionContent.forEach(accordion => {
        itemExpander(accordion, '.accordion-title', 3);
    });
}





const videoContent = document.querySelectorAll('.content.videos');

if ( videoContent ) {
    videoContent.forEach(videos => {
        itemExpander(videos, '.video', 3);
    });
}





const productFilterBtn = document.querySelector('.product-filter-btn');
if ( productFilterBtn ) {
    const filterOverlay = productFilterBtn.nextSibling;
    const closeBtn = filterOverlay.querySelector('.close-btn');
    const products = document.querySelectorAll('.producten-overview .product');
    const filterHolder = document.querySelector('.active-filters');
    const activeFilters = document.querySelectorAll('.active-filters .active-filter');
    const productCount = document.querySelector('.result-count .count');
    const filterInputs = document.querySelectorAll('.filter-item input');

    productFilterBtn.addEventListener('click', () => {
        filterOverlay.classList.add('open');
    });

    closeBtn.addEventListener('click', () => {
        filterOverlay.classList.remove('open');
    });

    filterOverlay.addEventListener('click', evt => {
        if ( evt.target.classList.contains('side-overlay') ) {
            filterOverlay.classList.remove('open');
        }
    });


    function displayFilters () {
        let selectedFilters = [];
        let hasFilters = false;

        filterOverlay.querySelectorAll('.checkbox:checked').forEach(selectedFilter => {
            const filterType = selectedFilter.dataset.type;
            const termId = selectedFilter.dataset.id;

            if (selectedFilters[filterType] === undefined) {
                selectedFilters[filterType] = [];
            }

            selectedFilters[filterType].push(termId);
        });

        if ( products && filterHolder ) {

            if (Object.keys(selectedFilters).length > 0 ) {

                [...products].forEach(product => {
                    product.style.display = 'block';
                });

                [...activeFilters].forEach(filter => {
                    filter.style.display = 'none';
                });

                for ( let key in selectedFilters ) {
                    [...products].filter(product => {
                        const ids = JSON.parse(product.dataset[key]);
                        return ids.find(id => selectedFilters[key].includes(String(id))) === undefined;
                    }).forEach(product => product.style.display = 'none');

                    [...activeFilters].filter(filter => {
                        const id = filter.dataset[key];
                        if (!id) return false;

                        filter.style.display = 'none';
                        return selectedFilters[key].includes(String(id));
                    }).forEach(filter => {
                        filter.style.display = 'inline-flex';
                        hasFilters = true;
                    });
                }
            } else {
                [...products].forEach(product => product.style.display = 'block');
                [...activeFilters].forEach(product => product.style.display = 'none');
            }

            if ( hasFilters ) {
                filterHolder.style.display = 'flex';
            } else {
                filterHolder.style.display = 'none';
            }

            productCount.innerHTML = document.querySelectorAll('.producten-overview .product[style*="display: block"]').length;
        }
    }


    filterOverlay.querySelectorAll('.checkbox').forEach(filter => {
        filter.addEventListener('change', displayFilters);
    });

    document.addEventListener('DOMContentLoaded', displayFilters);




    function setFilterCount () {
        filterInputs.forEach(input => {
            const dataType = input.dataset.type;
            const typeId = Number(input.dataset.id);

            const count = [...products].filter(product =>
                                JSON.parse(product.dataset[dataType]).includes(typeId) !== false
            ).length;

            input.nextSibling.querySelector('.count').innerHTML = count;
        });
    }

    document.addEventListener('DOMContentLoaded', setFilterCount);
}











const omschrijvingIntro = document.querySelector('.omschrijving .intro');
const omschrijvingFull = document.querySelector('.omschrijving .full');

if ( omschrijvingIntro && omschrijvingFull ) {
    const leesMeer = omschrijvingIntro.querySelector('.lees-meer');

    if ( leesMeer ) {
        leesMeer.addEventListener('click', _ => {
            leesMeer.style.display = 'none';
            omschrijvingFull.classList.toggle('visible');
        });
    }
}






document.addEventListener( 'wpcf7mailsent', function( evt ) {

    // Storing melden
    if ( evt.detail.contactFormId == 2665 ) {
        window.location.href = '/support/storing-melden/bedankt/';
    }

    // Onderhoudscontact
    if ( evt.detail.contactFormId == 2666 ) {
        window.location.href = 'bedankt/';
    }

    // Contact
    if ( evt.detail.contactFormId == 1794 ) {
        // Offerte aanvragen
        if ( evt.target.closest('.offerte-aanvragen-overlay') ) {
            window.location.href = '/contact/bedankt-offerte/';
        } else {
            window.location.href = '/contact/bedankt/';
        }
    }

}, false );






document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('table')
        .forEach(table => {
            const parent = table.parentElement;
            const tableHolder = document.createElement('div');
            tableHolder.classList.add('table-holder');

            tableHolder.append(table.cloneNode(true));
            parent.replaceChild(tableHolder, table);
        });
});
